export default class ImagePlaceholderFrame {
  constructor (element, args) {
    this.div = document.createElement('div')
    this.div.className = 'imagePlaceholder'

    this.setTitle(args.title)

    let fragment = document.createDocumentFragment()
    fragment.appendChild(this.div)

    if (element) {
      element.appendChild(fragment)
    }
  }

  getTitle () {
    return this.div.innerHTML
  }

  setTitle (title) {
    let display = title

    if (!display) {
      display = '?'
    }

    let pos = 0
    let r = Math.floor(display.charCodeAt(pos) % 26 * 10)

    if (display.length > 1) {
      pos = 1
    }

    let g = 192; // Math.floor((title.charCodeAt(pos) % 26) * 7) + 32

    if (display.length > 2) {
      pos = 2
    }

    let b = Math.floor(display.charCodeAt(pos) % 26 * 6)

    this.div.style.backgroundColor = 'rgb(' + r + ', ' + g + ', ' + b + ')'
    this.div.innerHTML = display.substring(0, 1).toUpperCase()
  }

  getElement () {
    return this.div
  }
}



// WEBPACK FOOTER //
// ./js/lib/ui/ImagePlaceholderFrame.js